import games from './games';
import groups from './groups';
import subgroups from './subgroups';
import filters from './filters';
import carousels from './carousels';
import resources from './resources';
import smartSearch from './smart-search';

export default {
  games,
  groups,
  subgroups,
  filters,
  carousels,
  resources,
  smartSearch,
};
